module.exports = __webpack_public_path__ + "img/26.731158d8.png";